/**
    * Map tool mode enum
    *
    * @param Select            -    Select tool
    * @param Draw              -    Draw tool
    * @param MapLayers         -    Map layers tool
    * @param Address           -    Address tool
    * @param Upload            -    Upload tool
    * @param More              -    (Non switchable)
    * @param MapSelector       -    Map selector (testing only)
    * @param PinDrop           -    Pin drop tool
	* @param Print             -    Print tool
	* @param Locations         -    Location selection tool
	* @param Measure           -    Measure tool
	* @param Filter            -    Sites filter
	* @param Cookiecutter      -    Cookie cutter (not an actual mode)
	* @param Tutorial          -    Tutorial popup
	* @param Permalink         -    Permalink tool
	* @param Annotation        -    Annotation tool
	* @param MapControl        -    Map control abilities
	* @param LinkedResources   -    Linked resources
	* @param Accessibility     -    Accessibility tool
*/
enum MapToolMode {
	Select,
	Draw,
	MapLayers,
	Address,
	Upload,
	More,
	MapSelector,
	PinDrop,
	Print,
	Locations,
	Measure,
	Filter,
	Tutorial,
	Permalink,
	Annotation,
	MapControl,
	LinkedResources,
	Accessibility
}

export default MapToolMode;